import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import AccountService from '../../Services/http/AccountService';
import IndexService from '../../Services/http/IndexService';
import { createAwsStateAndNavigateToAws, verifyAwsAuthorizationComplete } from '../Helper/AppApprovalHelper';
import { Alert, Box, CircularProgress } from '@mui/material';

// const application_url = "https://sellercentral.amazon.com/apps/authorize/consent";
// const application_id = 'amzn1.sp.solution.ede838cd-808b-4295-9026-c7400a165ed1';

const AwsDialog = () => {
  const [open, setOpen] = React.useState(false);
  const userRole = useSelector((state: any) => state.general.userRol);
  let defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );
  const isPartnerLoggedIn = useSelector((state: any) => state.partner.isPartnerLoggedIn);
  const [isVerifying, setIsVerifying] = useState(false);
  const [verificationError, setVerificationError] = useState<string | null>(null);

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return false; // prevent closing on backdrop click

    setOpen(false);
  };

  useEffect(() => {
    const checkIsInactiveAccount = async () => {
      const res = await AccountService.checkIsInactiveAccount(defaultAccount.id);

      if (res && res['is_inactive_account'] !== undefined) {
        setOpen(res['is_inactive_account']);
      }
    }
    // && userRole === 'account'
    if (defaultAccount && defaultAccount.id && userRole === 'account') {
      checkIsInactiveAccount();
    }
  }, [defaultAccount]);

  const handleVerifyAuthorization = async () => {
    if (!defaultAccount?.id) {
      setVerificationError("No account selected for verification");
      return;
    }
    try {
      setIsVerifying(true);
      setVerificationError(null);

      await verifyAwsAuthorizationComplete(defaultAccount.id);
      setOpen(false);
    } catch (error) {
      const errorMsg = error instanceof Error ? error.message : "Authorization verification failed";
      setVerificationError(errorMsg);
    } finally {
      setIsVerifying(false);
    }
  };
  // const createAwsStateAndNavigateToAws = () => {
  //   IndexService.createAwsState(defaultAccount.id).then((res) => {
  //     if (res && res["message"] === "success") {
  //       const searchParams = new URLSearchParams();
  //       searchParams.append('application_id', application_id);
  //       for (const key in res['params']) {
  //         searchParams.append(key, res['params'][key]);
  //       }
  //       const queryString = searchParams.toString();
  //       window.location.replace(`${application_url}?${queryString}`);
  //     } else {
  //       if (JSON.parse(JSON.stringify(res)).message === "account not found") {
  //         alert("account not found");
  //       } else if (JSON.parse(JSON.stringify(res)).message === "account invalid") {
  //         alert("account invalid");
  //       } else {
  //         alert("An error occurred during the AWS login");
  //       }
  //     }
  //   })
  // };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Authorize our app on Seller Central!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Thank you for signing up!<br /> We are now ready to set up your account.
            In order for us to bring Seller Central data into the platform to identify case discrepancies, we need you to set up access to your Seller Central.
            <br />
            Please Click the following link to authorize our app on Seller Central:
          </DialogContentText>
          {isPartnerLoggedIn && (
            <Box mt={3} sx={{ fontSize: "0.7rem", color: "#666" }}>
              <p>After authorizing in the popup window, click "I've Completed Authorization" to proceed.</p>
            </Box>
          )}
          {verificationError && (
            <Box>
              <Alert severity="error">{verificationError}</Alert>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1.5 }}>
          {/* <Button onClick={handleClose}>Not Now</Button> */}
          <Button onClick={() => createAwsStateAndNavigateToAws(defaultAccount.id, isPartnerLoggedIn)} autoFocus size="medium" sx={{ minWidth: 150 }} variant="contained">
            Authorize
          </Button>
          {isPartnerLoggedIn && (
            <Button
              onClick={handleVerifyAuthorization}
              disabled={isVerifying}
              variant="outlined"
              startIcon={isVerifying ? <CircularProgress size={20} /> : null}
              size="medium"
              sx={{ minWidth: 150 }}
            >
              {isVerifying ? "Verifying..." : "I've Completed Authorization"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AwsDialog;